/* eslint-disable */
import React from 'react';
import styles from './DevImport.module.css';

// DNA classification palette (Phase 2/3): New=green, Exact dup=ink-300,
// Soft conflict=amber, In-file dup=violet, Invalid=red, Total=ink-400.
const INK   = '#8e887b';
const GREEN = '#3a8845';
const DIM   = '#b8b2a4';
const AMBER = '#a86810';
const VIOLET = '#7c3aed';
const RED   = '#c0503f';

const CARDS = [
  { id: 'all',      key: 'total',              label: 'Total',         color: INK },
  { id: 'new',      key: 'new',                label: 'New',           color: GREEN },
  { id: 'exact',    key: 'exact_duplicate',    label: 'Exact dup',     color: DIM },
  { id: 'soft',     key: 'soft_conflict',      label: 'Soft conflict', color: AMBER },
  { id: 'internal', key: 'internal_duplicate', label: 'In-file dup',   color: VIOLET },
  { id: 'invalid',  key: 'invalid',            label: 'Invalid',       color: RED },
];

export function DevImportSummaryCards({ summary = {}, activeFilter, onFilterChange }) {
  return (
    <div className={styles.cards}>
      {CARDS.map(c => {
        const active = activeFilter === c.id;
        const value = c.id === 'all' ? (summary.total ?? 0) : (summary[c.key] ?? 0);
        return (
          <button
            key={c.id}
            onClick={() => onFilterChange && onFilterChange(c.id)}
            className={`${styles.card} ${active ? styles.cardActive : ''}`}
          >
            <span className={styles.cardTopBar} style={{ background: c.color }} />
            <div className={styles.cardLabel}>{c.label}</div>
            <div className={styles.cardVal} style={{ color: c.color }}>{value}</div>
          </button>
        );
      })}
    </div>
  );
}
